export const BUCKET_KEYS = ['recent', 'last7days', 'last30days', 'older'] as const

export type BucketKey = (typeof BUCKET_KEYS)[number]

export interface NotificationBucket<T> {
  key: BucketKey
  items: T[]
}

const HOURS_48_MS = 48 * 60 * 60 * 1000
const DAYS_7_MS = 7 * 24 * 60 * 60 * 1000
const DAYS_30_MS = 30 * 24 * 60 * 60 * 1000

export function groupByTimeBucket<T extends { createdAt: string }>(
  notifications: readonly T[],
  now: Date = new Date(),
): NotificationBucket<T>[] {
  const buckets: Record<BucketKey, T[]> = {
    recent: [],
    last7days: [],
    last30days: [],
    older: [],
  }
  const nowMs = now.getTime()

  for (const notification of notifications) {
    const ageMs = nowMs - new Date(notification.createdAt).getTime()
    if (ageMs < HOURS_48_MS) buckets.recent.push(notification)
    else if (ageMs < DAYS_7_MS) buckets.last7days.push(notification)
    else if (ageMs < DAYS_30_MS) buckets.last30days.push(notification)
    else buckets.older.push(notification)
  }

  return BUCKET_KEYS.map((key) => ({ key, items: buckets[key] })).filter((bucket) => bucket.items.length > 0)
}
